import React from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import "./Card.css";

function Card({ title, completed }) {
  return (
    <div className='wrapper'>
      <p>{title}</p>
      <ProgressBar
        maxCompleted={100}
        completed={completed}
        bgColor='#c8a519ce'
        height='13px'
        labelColor='#000'
        baseBgColor='#cacaca'
        width='100px'
        labelAlignment='center'
        labelSize='13px'
        animateOnRender={true}
        labelColor='#002E63'
      />
    </div>
  );
}

export default Card;
